import React from 'react';
import { useIntl } from 'react-intl';
import { Input } from 'semantic-ui-react';

const RequestInput = ({
  text,
  type,
  maxLength,
  icon,
  iconPosition,
  size,
  autoFocus,
  onChange,
}) => {
  const intl = useIntl();
  return (
    <Input
      fluid
      icon={icon}
      iconPosition={iconPosition}
      size={size}
      autoFocus={autoFocus}
      className="aridhia-request-input"
      value={text || ''}
      maxLength={maxLength}
      placeholder={intl.formatMessage({ id: `access.${type}.placeholder` })}
      onChange={(e, { value }) => onChange(value)}
    />
  );
};

export default RequestInput;
